import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { UtilsDragDropModule } from '@unico-people/shared/utils/utils-drag-drop';

import { FeatureUploadImportFilesComponent } from './feature-upload-import-files.component';
import { SegmentService } from 'ngx-segment-analytics';
@NgModule({
  imports: [CommonModule, UtilsDragDropModule, MatSnackBarModule],
  declarations: [FeatureUploadImportFilesComponent],
  exports: [FeatureUploadImportFilesComponent]
})
export class FeatureUploadImportFilesModule {}
